import type { HTMLAttributes, ReactNode } from "react"

import { cn } from "../../helpers"
import * as styles from "./header.styled"

type HeaderProps = HTMLAttributes<HTMLHeadingElement> & {
  description?: ReactNode
  descriptionSize?: "sm" | "md"
  wrapperClassName?: string
  descriptionClassName?: string
}

export const Header = ({
  className,
  description,
  descriptionSize,
  wrapperClassName,
  descriptionClassName,
  ...props
}: HeaderProps) => {
  return (
    <div className={styles.root}>
      <div className={cn(styles.wrapper, wrapperClassName)}>
        <h1 className={styles.title(className)} {...props} />
        {description ? (
          <p className={cn(styles.description(descriptionSize), descriptionClassName)}>
            {description}
          </p>
        ) : null}
      </div>
    </div>
  )
}
